import { Component, OnInit } from '@angular/core';
import { RedirectService } from '../../../core/services/redirect/redirect.service';

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
    standalone: false
})
export class FooterComponent implements OnInit {
  date: Date = new Date();
  constructor(private redirectService: RedirectService) { }

  ngOnInit() { }

  getRedirectURL(moduleURL: string) {
    return this.redirectService.getFullUrl(moduleURL, false);
  }

  links = [
    {
      text: "About Us",
      title: "Click here to go to About Us page.",
      url: "/about-us",
    },
    {
      text: "Contact Us",
      title: "Click here to go to Contact Us page.",
      url: "/contact-us"
      // this.getRedirectURL("ContactUs.aspx"),
    },
    // {
    //   text: "Feedback",
    //   title: "Click here to go to Feedback page.",
    //   url: this.getRedirectURL("Feedback.aspx"),
    // },
    {
      text: "Privacy Policies",
      title: "Click here to go to Privacy Policy page.",
      url: "/privacy-policies",
    },
    {
      text: 'Terms of Use',
      title: 'Click here to go to Terms of Use page.',
      url: '/terms-of-use',
      target: '_blank'
    }
  ];
}
